export const setCookie = (name, value, days) => {
	let expires = "";
	if (days) {
		let date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	if (process.env.NODE_ENV === "production") {
		document.cookie = name + "=" + (value || "") + expires + "; Domain=" + process.env.COOKIE_HOST + "; path=/";
	} else {
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}
};

export const getCookie = name => {
	let nameEQ = name + "=";
	let ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
};

export const deleteCookie = name => {
	document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const StofwareAuthMiddleware = store => next => action => {
	if (action) {
		if (action.type === "SET_USER") {
			if (action.user === null) {
				sessionStorage.removeItem("user");
			} else if (sessionStorage.getItem("user") !== action.user) {
				sessionStorage.setItem("user", JSON.stringify(action.user));
			}
		}
		if (action.type === "SET_ACCESS_TOKEN") {
			if (action.access_token === null) {
				sessionStorage.removeItem("access_token");
			} else if (sessionStorage.getItem("access_token") !== action.access_token) {
				sessionStorage.setItem("access_token", action.access_token);
			}
		}
		// This is needed for PWA Safari
		if (action.type === "SET_UNFRESH_ACCESS_TOKEN") {
			if (action.unfresh_access_token === null) {
				deleteCookie("unfresh_access_token");
			} else if (getCookie("unfresh_access_token") !== action.unfresh_access_token) {
				// Make cookie only availible for 15minutes
				setCookie("unfresh_access_token", action.unfresh_access_token, 0.01);
			}
		}

		if (action.type === "CLEAR_UNFRESH_ACCESS_TOKEN") {
			if (action.unfresh_access_token === null) {
				deleteCookie("unfresh_access_token");
			}
		}

		// if (action.type === 'SET_REFRESH_TOKEN') {
		//     if (action.refresh_token === null){
		//         deleteCookie('refresh_token_cookie');
		//     }
		//     else if (getCookie('refresh_token_cookie') !== action.refresh_token) {
		//         setCookie('refresh_token_cookie', action.refresh_token, 1);
		//
		//     }
		// }

		if (action.type === "CLEAR_TOKENS") {
			sessionStorage.removeItem("access_token");
			sessionStorage.removeItem("user");
			deleteCookie("unfresh_access_token");
		}
		return next(action);
	}
};

export default StofwareAuthMiddleware;
